import { getCookie, COOKIE } from 'apmui/common/Cookie';

const apmLog = getCookie(COOKIE.APM_LOG);

function divLog(...args: any[]) {
    if (apmLog) {
        const strings = args.map((x) => String(x));
        let div = document.getElementById('apm_div_log');
        if (!div) {
            div = document.createElement('div');
            div.id = 'apm_div_log';
            document.body.appendChild(div);
        }
        let message = strings.join(' ');
        message = message.replace(/<|>/g, (x) => escape(x)) + '<br>';
        div.innerHTML += message;
    }
}

export { divLog };
